export const OUT_OF_RANGE_DROPDOWN_ITEM_INDEX = -1
export const DROPDOWN_KEY_CODES = {
  '13': 'Enter',
  '40': 'ArrowDown',
  '38': 'ArrowUp'
}
